import { AppUserInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class AppUserInfoService {
	async getHideHelpSetting()  {
		if (this.currentAppUserInfo) {
			return this.currentAppUserInfo.hideHelp;
		}
		else {
			await this.getCurrentAppUserInfo();
			if (this.currentAppUserInfo) {
				return this.currentAppUserInfo.hideHelp;
			}
			else {
				//Should not get this far.
				return false;
			}
		}
    }

	currentAppUserInfo: AppUserInfo;

	async getCurrentAppUserInfo() {

		if (this.currentAppUserInfo) return this.currentAppUserInfo;

		this.currentAppUserInfo = await this.repository.find('getcurrentappuserinfo');
	}

	repository: any;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(AppUserInfo);
		this.getCurrentAppUserInfo();
	}

	getActiveTeamMembers() {
		return this.repository.find('getactive');

	}

	

}